import { Line } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { CHART_COLORS, CHART_OPTIONS } from './constants';

export const ContinuousChart = ({ plot, yAxisLabel, startYear, endYear }) => {
  const labels = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);

  const emissionLabels = Array.from(new Set(plot?.flatMap(node => node.emissions.map(e => e.label))));

  const datasets = emissionLabels.map((emissionLabel, index) => ({
    label: emissionLabel,
    data: plot.map(node => {
      const emission = node.emissions.find(e => e.label === emissionLabel);
      return emission ? emission.quantity.scalar : 0;
    }),
    fill: true,
    backgroundColor: CHART_COLORS[index],
    borderColor: 'transparent',
    tension: 0.4,
    pointRadius: 0,
  }));

  return (
    <Line
      data={{ labels, datasets }}
      options={{
        ...CHART_OPTIONS,
        plugins: {
          ...CHART_OPTIONS.plugins,
          yAxisLabel: {
            ...CHART_OPTIONS.plugins.yAxisLabel,
            text: yAxisLabel,
          },
        },
        elements: { line: { fill: true } },
      }}
    />
  );
};

ContinuousChart.propTypes = {
  plot: PropTypes.array,
  yAxisLabel: PropTypes.string,
  label: PropTypes.string,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
};
